module.exports = __webpack_public_path__ + "img/Super-Sam-SunHero-300-V1.6e891a61.svg";